import { ClientsService } from "@/services/api-service";
import lodash from "lodash";

const state = {
  count: 0,
  pages: 1,
  list: [],
  current: {},
  original: {},
  originalJSON: ""
};

const getters = {
  count: state => state.count,
  pages: state => state.pages,
  list: state => state.list,
  current: state => state.current,

  isDirty: state => {
    const currentJSON = JSON.stringify(state.current);
    return currentJSON !== state.originalJSON;
  }
};

const actions = {
  async fetchList(context, params) {
    if (params.offset === 0) context.commit("reset");
    const { data } = await ClientsService.query(params);
    context.commit("set", {
      result: data,
      limit: params.limit
    });
  },

  async fetch(context, id) {
    const { data } = await ClientsService.get(id);
    context.commit("setCurrent", data.client);
  },
  async add(context, client) {
    await ClientsService.add(client);
    await context.dispatch("fetchList", { limit: 20, offset: 0 });
  },
  async save(context) {
    const { data } = await ClientsService.save(state.current);
    context.commit("setCurrent", data.client);
  },
  async delete(context) {
    await ClientsService.destroy(state.current.clientId);
    context.commit("remove", state.current);
  },
  async clone(context, client) {
    const { data } = await ClientsService.clone(client);
    context.commit("setCurrent", data.client);
  },
  async addSecret(context, secret) {
    const { data } = await ClientsService.addSecret(
      state.current.clientId,
      secret
    );
    context.commit("setCurrent", data.client);
  },
  async removeSecret(context, secret) {
    lodash.remove(
      state.current.clientSecrets,
      item => item.value === secret.value
    );
    await context.dispatch("save");
  },
  async addGrantType(context, granttype) {
    state.current.allowedGrantTypes.push(granttype);
    await context.dispatch("save");
  },
  async removeGrantType(context, granttype) {
    lodash.remove(state.current.allowedGrantTypes, item => item === granttype);
    await context.dispatch("save");
  },
  async addResources(context, resource) {
    resource.forEach(r => {
      state.current.allowedScopes.push(r.name);
    });
    await context.dispatch("save");
  },
  async removeResources(context, resource) {
    resource.forEach(r => {
      lodash.remove(state.current.allowedScopes, item => item === r.name);
    });
    await context.dispatch("save");
  }
};

const mutations = {
  set(state, data) {
    state.list.push(...data.result.clients);
    state.count = data.result.clientsCount;
    state.pages =
      Math.ceil(state.count / data.limit) == 0
        ? 1
        : Math.ceil(state.count / data.limit);
  },
  reset(state) {
    state.list = [];
    state.count = 0;
    state.pages = 1;
  },
  setCurrent(state, entity) {
    state.original = entity;
    state.current = entity;
    state.originalJSON = JSON.stringify(state.original);
  },
  remove(state, entity) {
    state.list.splice(state.list.indexOf(entity), 1);
    state.current = {};
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
